var _path, _path2, _path3, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 73,
    viewBox: "0 0 94 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3804 15.9425C66.3804 15.9425 61.8506 18.0402 58.4943 17.6207C55.5575 16.362 50.6026 16.3981 49.2644 17.201C47.3598 18.3437 47.8999 22.1607 47.5864 24.7528C47.3245 26.9191 45.2945 29.4021 47.5865 31.885C54.299 39.1567 57.2358 35.2414 60.1726 39.0172C62.2966 41.7481 57.2358 54.9597 60.1726 57.0574C61.7563 58.1886 69.2825 50.3448 69.8219 47.8276C71.0805 41.954 74.2436 38.5647 74.4369 38.1781",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4426 31.4655C14.8622 33.9822 17.5573 36.4701 18.2185 38.1782C19.4829 41.4445 18.681 45.0434 19.8966 46.9885C21.9944 50.3449 24.5116 48.6667 24.5116 50.7644L25.7702 56.638L26.1898 60.4138M40.4541 7.5517C41.2932 11.3276 36.5968 11.2621 33.3219 13.8448C33.3219 13.8448 32.4829 16.362 30.8047 17.6207C29.9656 19.2988 29.1265 19.7184 28.707 21.8161C28.707 23.9138 29.6479 28.5288 29.1265 28.5288C28.2941 28.5288 28.0059 24.4438 24.9311 24.7529C19.4008 25.3089 18.638 29.3678 18.638 29.3678C18.638 29.3678 17.9048 32.578 18.638 34.4023C19.2875 36.0183 21.5748 37.7586 21.5748 37.7586C21.7925 37.3235 23.4005 33.3624 24.9311 32.7242C27.8679 31.4995 28.707 33.5632 32.9024 35.6609C36.6783 37.5489 35.0001 38.5977 37.9369 39.8563C40.4541 41.954 41.1181 40.4766 42.9714 42.7931C44.6495 44.8908 42.5518 47.8276 40.8737 49.9253C39.3722 51.3125 37.6192 53.7428 36.2587 55.3793L32.0633 59.1552L30.3852 62.931",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2299 66.9166C61.0286 66.9166 74.6466 53.2986 74.6466 36.5C74.6466 19.7013 61.0286 6.08331 44.2299 6.08331C27.4312 6.08331 13.8132 19.7013 13.8132 36.5C13.8132 53.2986 27.4312 66.9166 44.2299 66.9166Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1299_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 38.201C73.7759 38.201 83.4619 36.2473 85.4176 34.9423C87.3732 33.6373 83.4301 31.5523 74.9577 30.902",
    stroke: "black",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1299_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9026 38.201C15.1267 38.201 5.44068 36.2473 3.48503 34.9423C1.52939 33.6373 5.4725 31.5523 13.9449 30.902",
    stroke: "black",
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1299_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9998 42.8934C73.7757 42.8934 84.4616 40.9045 86.4173 39.5995C88.3729 38.2945 83.8049 35.1963 74.1889 35.0112",
    stroke: "black",
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1299_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9023 42.8934C14.1264 42.8934 3.44047 40.9045 1.48482 39.5995C-0.470823 38.2945 4.09724 35.1963 13.7132 35.0112",
    stroke: "black",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1299_2999",
    x: 63.6033,
    y: 29.3165,
    width: 28.7041,
    height: 12.4699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_2999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_2999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1299_2999",
    x: 2.59521,
    y: 29.3165,
    width: 28.7041,
    height: 12.4699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_2999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_2999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1299_2999",
    x: 63.603,
    y: 33.4257,
    width: 29.6555,
    height: 13.0531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_2999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_2999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1299_2999",
    x: 0.643555,
    y: 33.4257,
    width: 29.6555,
    height: 13.0531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_2999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_2999",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthIcon);
export default __webpack_public_path__ + "static/media/earth_icon.93d0d829c79c98bdfe61c473c76d348f.svg";
export { ForwardRef as ReactComponent };